<script lang="ts">
  import { cn } from '$lib/utils/misc';
  import CornerSquare from '../wrappers/CornerSquare.svelte';
</script>

<div
  class={cn(
    'flex min-h-[calc(100dvh-8rem)] items-center justify-center px-6 md:gap-x-[4rem] lg:gap-x-[7rem]',
    $$props.class,
  )}
>
  <img class="hidden w-32 md:block" src="/images/png/ascii-column-left.png" alt="Left Column" />
  <CornerSquare class="!h-fit max-h-none w-full sm:w-[420px]">
    <slot />
  </CornerSquare>
  <img class="hidden w-32 md:block" src="/images/png/ascii-column-right.png" alt="Right Column" />
</div>
